export enum EPropertyUrl {
  PROPERTIES = 'properties',
  UPLOAD = 'upload',
  PREVIEW_UPLOAD = 'preview-upload',
  UNITS = 'units',
  SEARCH = 'search',
  TYPES = 'types',
  TEMPLATE = 'template',
  POLICY = 'policy',
  NAME = 'name',
  PHOTO = 'photo',
  ONBOARD = 'onboard',
  DETAILS = 'details',
  PROPERTY_MANAGERS = 'property-managers',
  PROPERTY_MANAGEMENT = 'property-management',
  INVITATION = 'invitation',
  RESEND = 'resend',
  ASSIGNED = 'assigned',
  UNASSIGN = 'unassign',
  UNASSIGNED = 'unassigned',
  ASSIGN = 'assign',
  PET_CHARGES = 'pet-charges',
  DELETE = 'delete',
  PREVIEW = 'preview',
  UPLOADED_FILES = 'uploaded-files',
  TENANTS_SCREENING = 'existing-tenant-screening',
  SCREENING_CONFIGURATION = 'screening-configuration',
  FUTURE_PROPERTIES = 'future-properties',
  BILLING_METHOD = 'billing-method',
  FUTURE_PROPERTIES_NOTIFICATIONS = 'future-properties-notifications',
  UNIT = 'unit',
  NOTIFICATION = 'notification',
  NOTIFICATIONS = 'notifications',
  SUBSCRIBE = 'subscribe',
  UNSUBSCRIBE = 'unsubscribe',
  ENABLE = 'enable',
  DISABLE = 'disable',
  CONACT = 'contact',
  PRIMARY = 'primary',
  NON_PRIMARY = 'non-primary',
  METADATA = 'metadata',
  PM_NOTIFICATION_SETTINGS = 'pm-notification-settings',
  NOTIFICATION_OPTIONS = 'notification-options',
  BULK = 'bulk',
  EXPORT = 'export',
  TEAM_MEMBERS = 'team-members',
  PAYMENT_STATISTICS = 'payment-statistics',
  PAYMENT_SETTINGS = 'payment-settings',
  AFFORDABLE_HANDLING = 'affordable-handling',
  FEE_SUPPRESSION = 'fee-suppression',
  SUPPRESSION_STATUS = 'suppression-status',
  PMS_PREVIEW = 'pms-preview',
  DNA = 'dna',
  ANIMAL_TYPE_MANAGEMENT = 'animal-type-management',
}
